import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 4.8rem 2.4rem 2.4rem;
  background-color: rgba(0, 0, 0, 0.4);
`;

export const CloseIconLayout = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 4.4rem;
  height: 4.4rem;
  top: 1rem;
  right: 1rem;
  padding: 0;
  background-color: transparent;
  border: 0.2rem solid transparent;
  border-radius: 50%;
  transition: border-color 200ms;
  cursor: pointer;

  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.accent.blue[500]};
  }

  svg {
    fill: white;
    width: 3.2rem;
    height: 3.2rem;
  }
`;

export const VideoLayout = styled.div`
  width: 100%;
  max-width: 180rem;
  max-height: calc(100vh - 9.6rem);
`;
